<template>
  <div class="ts-h-48 ts-overflow-y-auto ts-overflow-x-hidden">
    <div class="text-center" v-if="branch_fetch">
      <i class="fa fa-spinner spin"></i>
    </div>
    <div
      class="row form-group"
      v-for="(branch, index) in branchList"
      :key="index"
    >
      <div class="col-md-12">
        <ts-checkbox v-model="model.branch_id_list" :value="branch.branch_id">{{
          branch.branch_name_en
        }}</ts-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'branchList',
  props: ['value'],
  data() {
    return {
      model: {},
      branch_fetch: true
    }
  },
  created() {
    ;(this.model = this.value),
      this.getBranch().finally(() => {
        this.branch_fetch = false
      })
  },
  computed: {
    ...mapState('feeSetup', ['branchList'])
  },
  methods: {
    ...mapActions('feeSetup', ['getBranch'])
  }
}
</script>
